export default __webpack_public_path__ + "static/media/sommer_1986_cover.dbc32e8a.webp";